import React from "react";
import JoinEvent from "../../pages/joinEvent/JoinEvent";
import "./AddEventModal.css";

const AddEventModal = ({ isOpen, onClose, onProceed }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <JoinEvent onClose={onClose} onProceed={onProceed} source="INVITES" />
      </div>
    </div>
  );
};

export default AddEventModal;
